import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CONFIRMATION, tm } from '../../shared/Constants/SharedConstants';
import creditCardImg from '../../assets/CreditCardBanner/creditcard_img.png';
import { CreditCardButton } from '../../shared/Buttons/CreditCardButton/CreditCardButton';
import { renderBrandStyle } from '../../shared/Utils/renderBrandStyle';
import './CreditCardBanner.scss';

const CreditCardBanner = (props) => {
    const {
        translations,
        vFlowSource,
        vMake,
        vThemeMake,
        dealershipSummary,
        cardholder,
        active,
        softEnroll,
        headerNav,
    } = props;

    const isCreditCardEligible = cardholder || !active || softEnroll || headerNav !== CONFIRMATION ? false : true;

    /**
     * The credit card banner should only be shown on the confirmation page and only for users that are not already cardholders, do not have the get loyalty flag enabled, and are not soft enrolled.
     */
    if (!isCreditCardEligible) {
        return null;
    }

    useEffect(() => {
        renderBrandStyle(dealershipSummary, vFlowSource, vThemeMake, vMake);
    }, [dealershipSummary, vFlowSource, vThemeMake, vMake]);

    return (
        <div>
            <div className="credit-card-banner">
                <div className="services-container header">
                    <h1 className="headline3">{translations.GM_REWARDS?.toUpperCase() + tm}</h1>
                    <div className="credit-card-container">
                        <div>
                            <img src={creditCardImg} alt="GM Rewards Credit Card Logo" width={200} />
                        </div>
                        <div>
                            <p>
                                With the GM Rewards™ Mastercard®, Cardmembers earn up to 10x points on GM purchases and
                                3x points on everyday purchases, redeemable toward Certified Service². Terms Apply.
                            </p>
                            <a href={translations.CREDIT_CARD_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer">
                                <CreditCardButton text={translations.LEARN_MORE} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        translations: state.countryOptionsReducer.translations,
        vFlowSource: state.prefillReducer.flowSource,
        vThemeMake: state.prefillReducer.themeMake,
        vMake: state.prefillReducer.make,
        dealershipSummary: state.prefillReducer.dealerSummaryObject.dealershipSummary,
        cardholder: state.myRewardsReducer.cardholder,
        softEnroll: state.myRewardsReducer.softEnroll,
        headerNav: state.headReducer.headerNavigation,
        active: state.myRewardsReducer.active,
    };
};

export default connect(mapStateToProps, {})(CreditCardBanner);
